<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g clip-path="url(#a)"><path fill-rule="evenodd" d="M11.333 9.333a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333zm0 18.667a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333zM14 16a2.667 2.667 0 11-5.333 0A2.667 2.667 0 0114 16zm6.667-6.667a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333zm2.666 16a2.667 2.667 0 11-5.333 0 2.667 2.667 0 015.333 0zm-2.666-6.666a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334z"/></g><defs><clipPath id="a"><path d="M0 0h32v32H0z"/></clipPath></defs></svg>